import { ORGANIZATION, SUPPLIER } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";
import { hasPermissionOnPlatform } from "src/context/permissionMatching";
import type { User } from "src/api/client-api/useUserNew";

export const canAdministerSuppliers = (user: User, action: Slugs): boolean =>
    hasPermissionOnPlatform(user, action, SUPPLIER) || hasPermissionOnPlatform(user, action, ORGANIZATION);
